module.exports = __webpack_public_path__ + "market/static/img/egg.2fcf3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/egg.png
// module id = +JBe
// module chunks = 1